import {
  GET_POSITION,
  SHOW_POSITION,
  CREATE_POSITION,
  EDIT_POSITION,
  DELETE_POSITION
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_POSITION]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/positions",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_POSITION]({ dispatch }, params) {
      let url = "/kanri/positions/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_POSITION]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/positions",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_POSITION]({ dispatch }, params) {
      let url = "/kanri/positions/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_POSITION]({ dispatch }, params) {
      let url = "/kanri/positions/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
